import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var demoIndices = ['center', 'practitioner'];
var defaultResults = {
  results: [{
    hits: []
  }]
};
/**
 * Rebalance results based on maxHits config on each index.
 * Briefly, if a query on an index returns less than a required maxHits, the remaining quota is rebalanced to the next set of results.
 */

export var rebalance = function rebalance(results, maxHitsByIndex) {
  var forwardedHitCount = 0;
  var data = results.reduce(function (result, _ref) {
    var index = _ref.index,
        queryID = _ref.queryID,
        hits = _ref.hits,
        _ref$balancedHits = _ref.balancedHits,
        balancedHits = _ref$balancedHits === void 0 ? 0 : _ref$balancedHits;
    var hitsToTake = ((maxHitsByIndex === null || maxHitsByIndex === void 0 ? void 0 : maxHitsByIndex[index]) || balancedHits) + forwardedHitCount;
    forwardedHitCount = Math.max(hitsToTake - hits.length, 0);
    var takes = hits.slice(0, hitsToTake).map(function (hit) {
      return _objectSpread(_objectSpread({}, hit), {}, {
        _algolia: {
          queryID: queryID,
          index: index
        }
      });
    });
    return result.concat(takes);
  }, []);
  return {
    data: data
  };
};

var Algolia = /*#__PURE__*/function () {
  function Algolia(client, params) {
    var _this = this;

    _classCallCheck(this, Algolia);

    /**
     * For mobile app only
     */
    _defineProperty(this, "search", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var isDemo,
            options,
            queries,
            results,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isDemo = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              options = _this.params.options;
              queries = options.map(function (obj) {
                var couldFilterDemoItem = demoIndices.some(function (i) {
                  return obj.index.endsWith(i);
                });
                var filters = '';

                if (couldFilterDemoItem && !isDemo) {
                  filters = 'isDemo!=1'; // normal user, returns only actual prat
                }

                return {
                  indexName: obj.index,
                  query: query,
                  params: {
                    hitsPerPage: _this.totalMaxHits,
                    filters: filters
                  }
                };
              });
              _context.next = 5;
              return _this.client.search(queries).catch(function () {
                return defaultResults;
              });

            case 5:
              results = _context.sent;
              return _context.abrupt("return", rebalance(results.results, _this.maxHitsByIndex));

            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    /**
     * Search single index, in order to make it cachable
     */
    _defineProperty(this, "searchSingleIndex", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, type) {
        var _results$results, _this$maxHitsByIndex$;

        var isDemo,
            userToken,
            couldFilterDemoItem,
            filters,
            queries,
            results,
            result,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isDemo = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              userToken = _args2.length > 3 ? _args2[3] : undefined;
              couldFilterDemoItem = demoIndices.some(function (i) {
                return type.endsWith(i);
              });
              filters = '';

              if (couldFilterDemoItem && !isDemo) {
                filters = 'isDemo!=1'; // normal user, returns only actual prat
              }

              queries = [{
                indexName: type,
                query: query,
                params: {
                  hitsPerPage: _this.totalMaxHits,
                  filters: filters,
                  userToken: userToken,
                  clickAnalytics: Boolean(userToken)
                }
              }];
              _context2.next = 8;
              return _this.client.search(queries).catch(function () {
                return defaultResults;
              });

            case 8:
              results = _context2.sent;
              result = _objectSpread({}, results === null || results === void 0 || (_results$results = results.results) === null || _results$results === void 0 ? void 0 : _results$results[0]);
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                balancedHits: (_this$maxHitsByIndex$ = _this.maxHitsByIndex[result.index]) !== null && _this$maxHitsByIndex$ !== void 0 ? _this$maxHitsByIndex$ : 0
              }));

            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    /**
     * Search multiple index
     */
    _defineProperty(this, "searchMultipleIndex", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query, types) {
        var isDemo,
            userToken,
            queries,
            results,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isDemo = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              userToken = _args3.length > 3 ? _args3[3] : undefined;

              if (Array.isArray(types)) {
                _context3.next = 4;
                break;
              }

              throw new Error('types should array');

            case 4:
              queries = types.map(function (type) {
                var couldFilterDemoItem = demoIndices.some(function (i) {
                  return type.endsWith(i);
                });
                var filters = '';

                if (couldFilterDemoItem && !isDemo) {
                  filters = 'isDemo!=1'; // normal user, returns only actual prat
                }

                return {
                  indexName: type,
                  query: query,
                  params: {
                    hitsPerPage: _this.totalMaxHits,
                    filters: filters,
                    userToken: userToken,
                    clickAnalytics: Boolean(userToken)
                  }
                };
              });
              _context3.next = 7;
              return _this.client.search(queries).catch(function () {
                return defaultResults;
              });

            case 7:
              results = _context3.sent;
              return _context3.abrupt("return", results.results.map(function (result) {
                var _this$maxHitsByIndex$2;

                return _objectSpread(_objectSpread({}, result), {}, {
                  balancedHits: (_this$maxHitsByIndex$2 = _this.maxHitsByIndex[result.index]) !== null && _this$maxHitsByIndex$2 !== void 0 ? _this$maxHitsByIndex$2 : 0
                });
              }));

            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));

      return function (_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }());

    this._agolia = client;
    this._client = null;
    this.params = params;
    this.maxHitsByIndex = params.options.reduce(function (obj, item) {
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, item.index, item.maxHits));
    }, {});
    this.totalMaxHits = params.options.reduce(function (current, item) {
      return current + item.maxHits;
    }, 0);
  }

  return _createClass(Algolia, [{
    key: "client",
    get: function get() {
      if (!this._client) {
        var _this$params2 = this.params,
            appId = _this$params2.appId,
            apiKey = _this$params2.apiKey;
        this._client = this._agolia(appId, apiKey);
      }

      return this._client;
    }
  }]);
}();

export default (function (client, params) {
  return new Algolia(client, params);
});
//# sourceMappingURL=algolia.js.map